import { useContext } from "react";
import { Button, Modal } from "react-bootstrap";
import { HomeContext } from "../../../../../../contexts/Home/HomeContext";

interface DataChartProps {
  show: boolean;
  changeModal: (value: boolean) => void;
  id: string;
  title: string;
}

const ModalConfirmation = ({ show, changeModal, id, title }: DataChartProps) => {
  const { duplicateDashboard } = useContext(HomeContext);

  const handleClose = () => {
    changeModal(false);
  };

  return show ? (
    <Modal
      size="sm"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={show}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>Tem certeza que deseja duplicar essa página?</Modal.Body>
      <Modal.Footer>
        <Button type="button" variant="secondary" onClick={handleClose}>
          Cancelar
        </Button>
        <Button
          type="button"
          variant="primary"
          onClick={() => {handleClose(), duplicateDashboard(id)}}
        >
          Duplicar
        </Button>
      </Modal.Footer>
    </Modal>
  ) : (
    <></>
  );
};

export default ModalConfirmation;
